import React, { Component } from 'react';
import { connect } from 'react-redux';

import './InvitationView.scss';
import InfoCircleIcon from '../../../global/img/InfoCircleIcon';
import InvitationCard from './InvitationCard';
import InvitationModal from './InvitationModal/InvitationModal';
import { accepteInvitation } from '../actions/action_acceptInvitation';
import { rejectInvitation } from '../actions/action_rejectInvitation';
import { fetchUserData } from '../../../global/app/actions/actions_fetchUsers';
class InvitationView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			view: '',
			chosenInvitatation: undefined,
			Invitations: this.props.currentUser.Invitations
		};
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.updateInvitation = this.updateInvitation.bind(this);
	}

	componentDidMount() {}

	openModal(view, invitation) {
		this.setState({
			showModal: true,
			view: view,
			chosenInvitation: invitation
		});
	}

	closeModal() {
		const { dispatch } = this.props;
		this.setState(
			{
				showModal: false,
				view: '',
				chosenInvitation: undefined
			},
			() => {
				dispatch(fetchUserData(fetchUserData()));
			}
		);
	}

	updateInvitation(result) {
		const { dispatch } = this.props;
		const { chosenInvitation } = this.state;
		if (result === 'Accepted' && chosenInvitation) {
			dispatch(accepteInvitation(chosenInvitation));
			this.setState({
				view: result
			});
		}
		if (result === 'Rejected' && chosenInvitation) {
			let newInvitationArray = [];
			this.state.Invitations.map((x) => {
				if (x.title !== chosenInvitation.title) {
					newInvitationArray.push(x);
				}
			});
			this.setState({
				view: result,
				Invitations: newInvitationArray
			});
			dispatch(rejectInvitation(chosenInvitation));
		}
	}

	render() {
		return (
			<div className="invitation-view-container">
				{this.state.showModal ? (
					<InvitationModal
						showModal={this.state.showModal}
						view={this.state.view}
						invitation={this.state.chosenInvitation}
						closeModal={this.closeModal}
						updateInvitaiton={this.updateInvitation}
					/>
				) : (
					''
				)}
				<div className="usa-profile-header invitation-view-header">
					<h3 className="usa-flag-page-header">You have a pending invitation(s)</h3>
					<h4 className="usa-flag-page-subheader">
						Link yourself to a network where you can share cases and profiles across accounts
					</h4>
					<div>
						<span className="invitation-icon">
							<InfoCircleIcon color={'#55575b'} />
						</span>
						<span className="invitation-info">
							You can only be linked to one network at a given time. If you wish to start your own
							network, you must first decline all pending invitations.
						</span>
					</div>
				</div>
				<div>
					{this.state.Invitations.map(function(index) {
						const keyValue = Math.random().toString().substr(2, 4);
						return <InvitationCard invitation={index} onClick={this.openModal} key={keyValue} />;
					}, this)}
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		dispatch
	};
};

const mapStateToProps = (state, props) => {
	return {
		currentUser: state.appReducer.userDataReducer.data
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(InvitationView);
